// add test

export const isSellerSendingExcessInventoryToEcom = (
  showAlreadyExcessInventory: boolean,
  replenishmentRecommendation: number | undefined,
  selectedQty: number
) =>
  !showAlreadyExcessInventory && replenishmentRecommendation ? replenishmentRecommendation + 50 < selectedQty : false;
